import { crmLeadParentApi } from '@/api'
import { isError } from '@/helpers/checkQuery'
import { Modal as AntdModal } from 'antd'
import jclasses from '@pages/Admin/CRM/styles/jsmodal.module.css'
import type { CrmLeadParent } from '@/api/types/crm/crmLeadParent.types'
import { getLeadParentApiErrorMessage } from './leadParentApiError'
import classes from './index.module.css'

interface HandlerDetachParentParams {
  leadId: number
  parent: CrmLeadParent
  /** У лида привязан ЛК ученика — отвязка затронет и ученика. */
  hasBoundStudent?: boolean
  addAlert: (data: {
    title: string
    text: string
    type: 'success' | 'error'
  }) => void
  onSuccess: (parents: CrmLeadParent[]) => void
}

export const handlerDetachParent = ({
  leadId,
  parent,
  hasBoundStudent = false,
  addAlert,
  onSuccess,
}: HandlerDetachParentParams) => {
  AntdModal.confirm({
    title: 'Отвязать родителя от лида?',
    content: (
      <div className={classes.modalContent}>
        <div className={classes.modalEntityName}>
          {parent.name || `ID ${parent.id}`}
        </div>
        {hasBoundStudent ? (
          <p className={classes.studentLinkHint}>
            У лида привязан ЛК ученика: родитель будет отвязан и от ученика.
          </p>
        ) : null}
      </div>
    ),
    icon: null,
    centered: true,
    maskClosable: true,
    className: jclasses.modal,
    okText: 'Отвязать',
    cancelText: 'Отмена',
    okButtonProps: { danger: true },
    onOk: async () => {
      try {
        const res = await crmLeadParentApi.detach({
          lead_id: leadId,
          parent_id: parent.id,
        })
        if (isError(res)) {
          throw Object.assign(new Error('detach failed'), { response: res })
        }

        const data = res.data.data
        addAlert({
          title: 'Успешно',
          text: data?.message || 'Родитель отвязан от лида.',
          type: 'success',
        })
        onSuccess(Array.isArray(data?.parents) ? data.parents : [])
      } catch (error) {
        addAlert({
          title: 'Ошибка',
          text: getLeadParentApiErrorMessage(
            error,
            'Не удалось отвязать родителя от лида',
          ),
          type: 'error',
        })
        throw error
      }
    },
  })
}
